export var selectFooterState = function selectFooterState(state) {
  return state.data;
};
export var selectUserAuth = function selectUserAuth(state) {
  if (!state) {
    return undefined;
  }
  return selectFooterState(state).auth;
};
export var selectTexts = function selectTexts(state) {
  var _selectFooterState;
  return (_selectFooterState = selectFooterState(state)) === null || _selectFooterState === void 0 ? void 0 : _selectFooterState.texts;
};
export var selectSiteMapTexts = function selectSiteMapTexts(state) {
  var footerState = selectFooterState(state);
  return {
    copyright: footerState.copyright,
    siteMapHref: footerState.siteMapHref,
    siteMapText: footerState.siteMapText
  };
};
export var selectSocialLinks = function selectSocialLinks(state) {
  var _selectFooterState2;
  return (_selectFooterState2 = selectFooterState(state)) === null || _selectFooterState2 === void 0 ? void 0 : _selectFooterState2.socialsLinks;
};